import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const contractSlice = createSlice({
  name: "contractDetails",
  initialState: {} as Record<string, any>,
  reducers: {
    setContractDetails: (_state: any, action: PayloadAction<any>) => ({
      ...action.payload,
    }),
  },
});

export const { setContractDetails } = contractSlice.actions;

export const contractDetails = contractSlice.reducer;

export default contractSlice.reducer;
